import React from 'react';
import { Button, useNotify, useRefresh, useDataProvider } from 'react-admin';
import { useCallback } from 'react';

const AssociateButton = ({ record, orgId, type, mode, title }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const associate = useCallback(() => {
    const uploadData = { id: orgId, data: { [type + "_ids" + mode]: [record.id] } }
    console.log('uploadData', uploadData)
    dataProvider.update('organizations', uploadData)
      .then(() => {
        notify(type + ' record association modified');
        refresh();
      })
      .catch((error) => {
        notify('Error: could not modify associate' + type, 'warning')
      });
  }, [dataProvider, notify, refresh, record, orgId]);

  return <Button label={title} onClick={associate} />;
};

export default AssociateButton;
